import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const TimeToBuySurveyAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "time-to-buy-survey" */ './time-to-buy-survey'),
  componentName: 'TimeToBuySurvey',
});
